<script>
    import {getNextInputId} from '../../helper/UIHelper';  
    export let model;
    export let label;
    export let uid;
    let className = "";
    export {className as class};

    if(uid == null)
      uid = getNextInputId();
</script>

<!-- <div class="{className}">
      {#if label}
      <label class="block text-gray-700 text-sm font-bold mb-2" for="{uid}">
        {label}
      </label>
      {/if}
      <input bind:value={model} 
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
            id="{uid}" 
            type="text" 
            placeholder="{label}"
            on:blur>
</div> -->

<div class="{className}">
  {#if label != null}
  <label for="{uid}" class="block text-sm font-medium leading-5 text-gray-700 mb-1">{label}</label>
  {/if}
    <div class="rounded-md shadow-sm">
      <input bind:value={model} id="{uid}" type="text" on:blur on:keyup on:focus class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 text-main" />
    </div>
</div>
